var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

var SvgMail = function SvgMail(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#6136FF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 20.038a1.73 1.73 0 0 1-1.731 1.731H10.23a1.73 1.73 0 0 1-1.731-1.73v-5.47a.3.3 0 0 1 .45-.254l5.677 3.554c.408.27.883.421 1.373.439a2.7 2.7 0 0 0 1.384-.393l5.677-3.553a.288.288 0 0 1 .288 0 .3.3 0 0 1 .15.253v5.423Zm0-8.007-7.004 4.384a.865.865 0 0 1-.912 0l-7.038-4.384a.08.08 0 0 1 0-.07 1.73 1.73 0 0 1 1.685-1.73h11.538a1.73 1.73 0 0 1 1.73 1.73.069.069 0 0 1-.034.07h.034Z",
    fill: "#6136FF"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgMail);
export default ForwardRef;